// Hook odpowiedzialny za pobranie dodatkowych informacji dla koszyka

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

// typ pojedynczej informacji
export interface ICartAdditionalInformationItem {
  style: string;
  message_html: string;
}

// typ zwracanych danych
export interface ICartAdditionalInformationResponse {
  items: ICartAdditionalInformationItem[];
}

const getCartAdditionalInformation = (
  cartId: number
): Promise<ICartAdditionalInformationResponse> =>
  axios.get(`carts/${cartId}/additional-information`);

export const useGetCartAdditionalInformation = (
  cartId: number,
  options?: UseQueryOptions<ICartAdditionalInformationResponse, IError>
) =>
  useQuery<ICartAdditionalInformationResponse, IError>(
    ['cart-additional-information', cartId],
    () => getCartAdditionalInformation(cartId),
    options
  );
